import { AppConfig } from '../../app-config'
import { SET_USER_DETAILS } from '../../store/Constants'
import { triggerSimpleAjax } from '../http-helper'
import { trackEvent, trackProfile } from '../ML/EventsTracker'

// Get user details - Josan
export default function getUserDetails({
	req_data = {},
	authType = null,
	triggerMultipleEvents = [],
	dispatch,
	reduxDispatch,
}) {
	return new Promise((res, rej) => {
		let url = `${AppConfig.api_url}user/getUserDetails`
		triggerSimpleAjax({
			url,
			method: 'GET',
			body: req_data,
			onSuccess: response => {
				dispatch &&
					dispatch({
						type: SET_USER_DETAILS,
						payload: {
							...response.data,
							isFetched: true,
						},
					})

				reduxDispatch &&
					reduxDispatch({
						type: SET_USER_DETAILS,
						payload: {
							...response.data,
							isFetched: true,
						},
					})

				localStorage.setItem(
					'show_combined_logo',
					response.data.showClubMahindraLogo,
				)

				localStorage.setItem(
					'show_ixigo_logo',
					response?.data?.partner === 'IXIGO',
				)

				// track profile if valid auth type is passed
				authType && response.data && response.data.loggedIn
				trackProfile(authType, {
					...response.data,
					prod_type: req_data.prod_type,
				})

				triggerMultipleEvents.forEach(event => {
					trackEvent(event.event, event.eventProps)
				})

				res(response.data)
			},
			onFailure: () => {
				dispatch &&
					dispatch({
						type: SET_USER_DETAILS,
						payload: {},
					})

				reduxDispatch &&
					reduxDispatch({
						type: SET_USER_DETAILS,
						payload: {},
					})

				rej('Failed - user details')
			},
		})
	})
}
